var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 8.48L8.219 11.6a.706.706 0 01-1.01 0 .735.735 0 010-1.028l4.181-4.253A.726.726 0 0112.001 6c.258 0 .483.128.609.32l4.18 4.252a.735.735 0 010 1.027.706.706 0 01-1.01 0L12.715 8.48v8.853c0 .369-.32.667-.714.667-.394 0-.714-.298-.714-.667V8.48z",
    fill: "#FFF"
  })));
};
export default SvgSend;